import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DEMO_MATCHES } from '../data/demo';
import Avatar from '../components/ui/Avatar';
import { FiSearch } from 'react-icons/fi';

const Messages = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 90 }}>
      <div style={{ padding: '16px 20px 0' }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 16 }}>Messages</h1>
        <div style={{ position: 'relative', marginBottom: 8 }}>
          <FiSearch style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#71717A' }} size={18} />
          <input placeholder="Search conversations..."
            style={{
              width: '100%', padding: '12px 16px 12px 42px',
              background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: 14, color: '#FFFFFF', fontSize: 14, fontFamily: 'Inter', outline: 'none',
            }} />
        </div>
      </div>

      <div style={{ padding: '0 4px' }}>
        {DEMO_MATCHES.map(m => (
          <button key={m._id} onClick={() => navigate(`/chat/${m._id}`)}
            style={{
              display: 'flex', alignItems: 'center', gap: 14, width: '100%',
              padding: '14px 20px', background: 'none', border: 'none',
              cursor: 'pointer', fontFamily: 'Inter', textAlign: 'left',
              borderBottom: '1px solid rgba(255,255,255,0.03)',
            }}>
            <Avatar src={m.user.photos?.[0]} name={m.user.name} size={56} online={m._id === 'm1'} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 style={{ fontSize: 15, fontWeight: 600, color: '#FFFFFF' }}>{m.user.name}</h4>
                <span style={{ fontSize: 11, color: '#52525B' }}>{m._id === 'm1' ? 'Yesterday' : m._id === 'm2' ? '2d ago' : '3d ago'}</span>
              </div>
              <p style={{
                fontSize: 13, color: m.unread > 0 ? '#FFFFFF' : '#71717A',
                fontWeight: m.unread > 0 ? 500 : 400,
                marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>{m.lastMessage}</p>
            </div>
            {m.unread > 0 && (
              <div style={{
                width: 20, height: 20, borderRadius: 10,
                background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 11, fontWeight: 700, color: 'white', flexShrink: 0,
              }}>{m.unread}</div>
            )}
          </button>
        ))}
      </div>

      {DEMO_MATCHES.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 32px' }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>💬</div>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>No messages yet</h3>
          <p style={{ fontSize: 14, color: '#71717A' }}>Start a conversation with your matches</p>
        </div>
      )}
    </div>
  );
};

export default Messages;
